import React from 'react';
import { Link } from 'react-router-dom';
import {
  filterUpdatesByCategory,
  getUpdateCategoryLabel,
  getUsedUpdateCategories,
  isNewUpdate,
} from '../../../data/help';
import { formatHelpDate, getHelpArticlePath } from './helpFormat';

export const UpdateCategoryFilter = ({ items, activeCategory, onChange }) => {
  const categories = getUsedUpdateCategories(items);
  const options = [{ id: null, label: '전체' }, ...categories];
  return (
    <div className="help-filter" role="group" aria-label="분야로 보기">
      {options.map((option) => {
        const selected = option.id === activeCategory;
        return (
          <button
            key={option.id || 'all'}
            type="button"
            aria-pressed={selected}
            className={`help-filter__chip${selected ? ' help-filter__chip--active' : ''}`}
            onClick={() => onChange(option.id)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export const UpdateCard = ({ item, linkState, now }) => (
  <Link to={getHelpArticlePath(item.id)} state={linkState} className="help-card">
    <div className="help-card__top">
      <time className="help-card__date" dateTime={item.date}>{formatHelpDate(item.date)}</time>
      {isNewUpdate(item, now) && <span className="help-new-badge">NEW</span>}
    </div>
    <h2 className="help-card__title">{item.title}</h2>
    {item.summary && <p className="help-card__summary">{item.summary}</p>}
    {item.categories?.length > 0 && (
      <div className="help-card__chips">
        {item.categories.map(category => (
          <span key={category} className="help-chip">{getUpdateCategoryLabel(category)}</span>
        ))}
      </div>
    )}
  </Link>
);

const UpdateList = ({ items, activeCategory, onCategoryChange, linkState, now = Date.now() }) => {
  const visible = filterUpdatesByCategory(items, activeCategory);
  return (
    <>
      <UpdateCategoryFilter items={items} activeCategory={activeCategory} onChange={onCategoryChange} />
      <ul className="help-card-list">
        {visible.map(item => (
          <li key={item.id}>
            <UpdateCard item={item} linkState={linkState} now={now} />
          </li>
        ))}
      </ul>
    </>
  );
};

export default UpdateList;
